import { useState } from "react";

export const useModal = (defaultValue = false) => {
  const [shown, setShown] = useState(defaultValue);

  const open = () => setShown(true);
  const close = () => setShown(false);

  return {
    shown,
    open,
    close,
  };
};
